<template>
  <div class="great-event">
    <div class="search-header">
      <div class="search-header-extra">
        <div class="add-contact" @click="onEdit">新增荣获奖项</div>
      </div>
    </div>
    <div class="search-table">
      <Table :columns="columns" :rows-data="rowsData">
        <template slot-scope='scope'>
          <div v-if="scope.col.key === 'op'" class="table-op">
            <a @click="onEdit(scope.row)">编辑</a>
            <span class="split-line"></span>
            <a class="del" @click="onDelete(scope.row)">删除</a>
          </div>
          <div v-else-if="scope.col.key === 'attachFileList'&& scope.row['attachFileList'].length">
            <a @click="onShowFile(scope.row['attachFileList'])">查看附件</a>
            <!-- <a
              v-for="(file, idx) in scope.row['attachFileList']"
              :key="idx"
              :title="scope.row['attachFileListTitle']"
              target="_blank"
              :href="file.url"
              style="display: block;"
              >{{file.name}}
            </a> -->
          </div>
        </template>
      </Table>
    </div>
    <Modal :visible="modalVisible" :appendBody="true">
      <div class="event-modal">
        <div class="modal-header">
          <span>添加荣获奖项</span>
          <i class="close" @click="onModalClose"></i>
        </div>
        <div class="content-content">
          <div class="form-item">
            <div class="form-item-label">标&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;题：</div>
            <div class="form-item-value" :class="form.awardTitle.error ? 'error' : ''">
              <input type="text" placeholder="请输入标题" v-model="form.awardTitle.value" @blur="validate(form.awardTitle)" />
              <div class="error-tip">{{form.awardTitle.error}}</div>
            </div>
          </div>
          <div class="form-item">
            <div class="form-item-label">时&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;间：</div>
            <div class="form-item-value date-form-item" :class="form.winDate.error ? 'error' : ''">
              <Datetime
                class="datetime-picker"
                format="YYYY-MM-DD"
                :placeholder="'请选择时间'"
                v-model="form.winDate.value"
                @input="validate(form.winDate)"
              />
              <div class="error-tip">{{form.winDate.error}}</div>
            </div>
          </div>
          <div class="form-item">
            <div class="form-item-label">奖项描述：</div>
            <div class="form-item-value textarea-form-item" :class="form.awardContent.error ? 'error' : ''">
              <textarea
                  placeholder="请输入奖项描述"
                  v-model="form.awardContent.value"
                  @blur="validate(form.awardContent)"
                ></textarea>
              <div class="error-tip">{{form.awardContent.error}}</div>
            </div>
          </div>
          <div class="form-item upload-item">
            <div class="form-item-label">相关附件：</div>
            <div class="upload-wrap">
              <div class="upload-add" :class="loading ? 'loading' : ''">
                上传附件
                <input v-if="!loading" type="file" accept="image/*" @change="onFileChange">
              </div>
              <div class="error-tip" v-if="form.attachFileList.error">{{form.attachFileList.error}}</div>
              <div class="upload-file-wrap">
                <div class="upload-file"
                      v-for="(item, index) in form.attachFileList.value"
                      :key="index">
                  <img :src="item.url" alt="">
                  <span>{{item.name}}</span>
                  <i class="upload-file-delete" @click="deleteFile(index)"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="cancel" @click="onModalClose">取消</button>
          <button class="confirm" @click="onConfirm">确定</button>
        </div>
      </div>
    </Modal>
    <Modal :visible="showFileModalVisible" :appendBody="true">
      <div class="event-modal">
        <div class="modal-header">
          <span>相关附件</span>
          <i class="close" @click="onFileModalClose"></i>
        </div>
        <div class="content-content">
          <div v-for="(item, index) in currentShowFileList" style="margin:30px 20px 40px 20px ">
            附件{{index+1}}：<a :href="item.url" target="_blank" >{{item.name}}</a>
          </div>                  
        </div>
        <div class="modal-footer">
          <button class="cancel" @click="onFileModalClose">取消</button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { uuid } from "@/service/util";
import { mapState } from 'vuex';
import Modal from '@/components/Modal';
import modal from '@/components';
import Table from '@/components/Table';
import Datetime from "@/components/DatetimePicker";
import upload from '@/service/upload';
import { getWinAwardList, addWinAward, editWinAward, removeWinAward } from '../service/api';
import moment from 'moment';
export default {
  data() {
    return {
      current: 1,
      columns: [{
        key: 'awardTitle',
        dataIndex: 'awardTitle',
        name: '奖项标题',
        maxWidth: '200px'
      }, {
        key: 'winDate',
        dataIndex: '_winDate',
        name: '发生时间'
      }, {
        key: 'awardContent',
        dataIndex: 'awardContent',
        name: '奖项描述',
        maxWidth: '200px'
      }, {
        key: 'attachFileList',
        dataIndex: 'attachFileList',
        name: '附件',
        maxWidth: '200px'
      }, {
        key: 'op',
        name: '操作'
      }],
      rowsData: [],
      modalVisible: false,
      currentShowFileList: [],
      showFileModalVisible: false,
      form: {
        awardTitle: {
          value: '',
          error: false,
          validate: v => {
            if (!v) {
              this.form.awardTitle.error = '请输入奖项标题';
              return false;
            }
            this.form.awardTitle.error = null;
            return true;
          }
        },
        winDate: {
          value: '',
          error: false,
          validate: v => {
            if (!v) {
              this.form.winDate.error = '请选择时间';
              return false;
            }
            this.form.winDate.error = null;
            return true;
          }
        },
        awardContent: {
          value: '',
          error: false,
          validate: v => {
            if (!v) {
              this.form.awardContent.error = '请输入奖项内容';
              return false;
            }
            this.form.awardContent.error = null;
            return true;
          }
        },
        attachFileList: {
          value: [],
          error: false,
          validate: v => {
            if (!v.length) {
              this.form.attachFileList.error = '请上传图片至少1张';
              return false;
            }
            this.form.attachFileList.error = null;
            return true;
          }
        },
      },
      loading: false
    }
  },
  computed: {
    ...mapState(['user']),
  },
  components: {
    Modal,
    Table,
    Datetime
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.searchData();
    },
    validate(field) {
      if (field.validate) {
        field.validate(field.value);
      }
    },
    searchData() {
      this.current = 1;
      this.getWinAwardList();
    },
    getWinAwardList() {
      getWinAwardList({
        current: this.current,
        pageSize: 10,
        orgId: this.user.memOrgVo.id
      }).then(res => {
        this.rowsData = (res.list || []).map(item => {
          if (item.winDate) {
            item._winDate = moment(item.winDate * 1000).format('YYYY-MM-DD');
          }
          item.attachFileList = item.attachFileList || [];
          item.attachFileListTitle = item.attachFileList.map((item) => item.name).join(",");
          return item;
        });
        console.log(this.rowsData);
      })
    },
    onFileChange($event) {
			const file = $event.target.files[0];
			if (this.loading) return false;
			this.loading = true;
			upload(file).then(url => {
				this.form.attachFileList.value.push({
          fileBizType: "cover",
          type: "image/png",
          uid: uuid(),
					name: file.name,
					url
				})
			}).finally(() => {
				this.loading = false;
			})
		},
		deleteFile(idx) {
			this.form.attachFileList.value.splice(idx, 1);
		},
    validateForm() {
      for(let key in this.form) {
        const field = this.form[key];
        if (field instanceof Object && field.validate && !field.validate(field.value)) {
          return false;
        }
      }
      return true;
    },
    onConfirm() {
      const validForm = this.validateForm();
      if (!validForm) {
        this.$message({
          type: 'error',
          content: '表单填写不正确'
        })
        return false;
      }
      const params = {
        orgId: this.user.memOrgVo.id,
        awardTitle: this.form.awardTitle.value,
        winDate: new Date(this.form.winDate.value).getTime() / 1000,
        awardContent: this.form.awardContent.value,
        attachFileList: this.form.attachFileList.value,
      }
      let apiFunc = addWinAward;
      if (this.form.id) {
        params.id = this.form.id;
        apiFunc = editWinAward;
      }
      apiFunc(params).then(() => {
        this.searchData();
        this.onModalClose();
        this.$message({
          type: 'success',
          content: '操作成功'
        });
      }).catch(err => {
        this.$message({
          type: 'error',
          content: err
        });
      })
    },
    onModalClose() {
      this.loading = false;
      this.modalVisible = false;
    },
    resetForm() {
      Object.values(this.form).map(item => {
        if (item instanceof Object) {
          item.error = null;
        }
      })
    },
    onEdit(row = {}) {
      row = JSON.parse(JSON.stringify(row));
      this.resetForm();
      this.form.id = row.id;
      this.form.awardTitle.value = row.awardTitle || '';
      if (row.winDate) {
        this.form.winDate.value = moment(row.winDate * 1000).format('YYYY-MM-DD');
      } else {
        this.form.winDate.value = moment().format('YYYY-MM-DD');
      }
      this.form.awardContent.value = row.awardContent || '';
      this.form.attachFileList.value = row.attachFileList || [];
      this.modalVisible = true;
    },
    onShowFile(fileList) {       
      this.currentShowFileList = fileList;
      this.showFileModalVisible = true;
    },
    onFileModalClose() {
      this.showFileModalVisible = false;
      this.currentShowFileList = [];
    },
    
    onDelete(row) {
      modal.confirm({
        title: '请确认是否删除该荣获奖项？',
        confirm:() => {
          return removeWinAward({
            id: row.id
          }).then(() => {
            this.searchData();
            this.$message({
              type: 'success',
              content: '删除成功'
            });
          }).catch(err => {
            this.$message({
              type: 'error',
              content: err
            });
          });
        },
      });
    },
  }
}
</script>

<style lang="less" scoped>
.search-header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 16px;

  .search-box {
    display: flex;
    align-items: center;

    .search-input-box {
      padding: 0 16px;
      height: 30px;
      background: #F5F5F5;

      input {
        width: 300px;
        height: 100%;
        font-size: 14px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: 500;
        color: #131415;
      }
    }

    .search-btn {
      width: 80px;
      height: 30px;
      cursor: pointer;
      background: #06AE63;
      display: flex;
      align-items: center;
      justify-content: center;

      i {
        width: 24px;
        height: 24px;
        margin-right: 4px;
        background: url(../../../assets/images/icon-search.png) no-repeat center
          center;
        background-size: 100% 100%;
      }

      span {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
      }
    }
  }

  .search-header-extra {
    margin-left: auto;
    
    .add-contact {
      padding-left: 22px;
      cursor: pointer;
      background: url(../../../assets/images/icon-add.png) no-repeat 0
        center;
      background-size: 18px 18px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #06AE63;
    }
  }
}
.event-modal {
  width: 640px;
  background: #FFFFFF;
  padding: 30px 0;
  box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.0600);

  .modal-header {
    font-size: 20px;
    font-family: PingFang-SC-Bold, PingFang-SC;
    font-weight: bold;
    color: #333333;
    text-align: center;
    margin-bottom: 40px;
    position: relative;

    i {
      cursor: pointer;
      width: 20px;
      height: 20px;
      background: url(../../../assets/images/icon-close.png) no-repeat center center;
      background-size: 100% 100%;
      position: absolute;
      right: 20px;
      top: 0;
    }
  }

  .content-content {
    margin-bottom: 20px;

    .form-item {
      padding: 0 40px 0 56px;
      margin-bottom: 24px;
      display: flex;
      align-items: center;

      &.upload-item {
        align-items: flex-start;
      }


      &-label {
        width: 80px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #262626;
        margin-right: 20px;
      }

      &-value {
        flex: 1;
        height: 46px;
        background: #F5F5F5;
        position: relative;

        &.date-form-item {
          padding-left: 16px;
          display: flex;
          align-items: center;
        }

        &.textarea-form-item {
          height: 152px;
        }

        .error-tip {
          position: absolute;
          left: 0;
          top: 100%;
          font-size: 12px;
          color: #FF3B2F;
          line-height: 20px;
          display: none;
        }

        &.error {
          border: 1px solid #FF3B2F;

          .error-tip {
            display: block;
          }
        }

        &.info {
          .error-tip {
            display: block;
            color: #06AE63;
          }
        }

        input {
          width: 80%;
          height: 100%;
          padding: 0 16px;
        }

        textarea {
          width: 100%;
					height: 120px;
					display: block;
					resize: none;
					box-sizing: border-box;
					outline: none;
					border: none;
					padding: 16px;
					background: inherit;
        }
      }

      .upload-wrap {
        .error-tip {
          font-size: 12px;
          color: #FF3B2F;
          line-height: 20px;
        }
        
        .upload-file-wrap {
          display: flex;
          flex-wrap: wrap;
          padding-top: 20px;
          
          .upload-file {
            padding: 10px;
            color: #06AE63;
            border-radius: 5px;
            margin-right: 20px;
            margin-bottom: 10px;
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;

            > img {
              width: 50px;
              height: 50px;
              display: block;
              margin-bottom: 5px;
            }

            span {
              width: 80px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            
            &:hover {
              .upload-file-delete {
                display: block;
              }
            }
            
            &-delete {
              display: none;
              cursor: pointer;
              width: 15px;
              height: 15px;
              position: absolute;
              right: -4px;
              top: -4px;
              background: #FF3B2F url(../../../assets/images/icon-close.png) no-repeat center center;
              background-size: 6px 6px;
              border-radius: 50%;
            }
          }
        }

        .upload-add {
          padding: 10px;
          color: #ffffff;
          border-radius: 5px;
          width: 100px;
          padding-left: 30px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          background: #06AE63 url(../../../assets/images/icon-upload.png) no-repeat 5px center;
          background-size: 20px 20px;
          position: relative;
          
          &.loading {
            background-image: url(../../../assets/images/icon-loading.gif);
            background-position: center center;
          }
          
          > input {
            position: absolute;
            cursor: pointer;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            opacity: 0;
          }
        }
      }
    }

    hr {
      height: 1px;
      background: #EEEEEE;
      margin: 16px 0 20px 0;
    }

    .notice-tip {
      padding: 0 40px 0 56px;
      display: flex;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #787878;
      line-height: 24px;

      .icon-notice {
        width: 16px;
        height: 16px;
        display: block;
        margin-top: 4px;
        margin-right: 8px;
      }
    }
  }

  .modal-footer {
    display: flex;
    align-items: center;
    justify-content: center;

    button {
      width: 120px;
      height: 40px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      outline: none;
      border: none;
      cursor: pointer;

      &.cancel {
        margin-right: 20px;
        color: #06AE63;
        background: rgba(6,174,99,0.1000);
      }

      &.confirm {
        background: #06AE63;
        color: #FFFFFF;
      }
    }
  }
}
</style>